import { UMS } from "~/apis/basePaths";

import api from "./api";

export const fetchProfiles = query =>
  api.get({
    path: `${UMS}/user/profiles`,
    query,
  });
